import { IInitialCatalogCsvUploadState } from 'interfaces/catalogCsvUpload.interface';
import * as CatalogCsvUploadType from './catalogCsvUpload.types';
import moment from 'moment';

export default function superAdminReducer(
  state: IInitialCatalogCsvUploadState,
  action: any
) {
  const { type, payload } = action;

  switch (type) {
    case CatalogCsvUploadType.SET_REPORTS_BY_UPLOAD: {
      const setReportsByUpload: IInitialCatalogCsvUploadState = {
        ...state,
        reportsByUpload: payload,
      };
      return setReportsByUpload;
    }

    case CatalogCsvUploadType.SET_IS_LOADING_BY_UPLOAD: {
      const setIsLoadingByUpload: IInitialCatalogCsvUploadState = {
        ...state,
        isLoadingByUpload: payload,
      };
      return setIsLoadingByUpload;
    }

    case CatalogCsvUploadType.SET_PUBLISH_UPLOAD: {
      const setPublishUpload: IInitialCatalogCsvUploadState = {
        ...state,
        reportsByUpload: state.reportsByUpload.map((report) => {
          if (report.id === payload.uploadId) {
            return {
              ...report,
              published: payload.publish,
              updatedAt: moment().toISOString(),
            };
          }
          return report;
        }),
      };
      return setPublishUpload;
    }

    case CatalogCsvUploadType.SET_IS_LOADING_PUBLISH_UPLOAD: {
      const setIsLoadingPublishUpload: IInitialCatalogCsvUploadState = {
        ...state,
        isLoadingPublishUpload: payload,
      };
      return setIsLoadingPublishUpload;
    }

    case CatalogCsvUploadType.SET_REJECT_UPLOAD: {
      const setRejectUpload: IInitialCatalogCsvUploadState = {
        ...state,
        reportsByUpload: state.reportsByUpload.filter((report) => report.id !== payload),
      };
      return setRejectUpload;
    }

    case CatalogCsvUploadType.SET_IS_LOADING_REJECT_UPLOAD: {
      const setIsLoadingRejectUpload: IInitialCatalogCsvUploadState = {
        ...state,
        isLoadingRejectUpload: {
          isLoading: payload.isLoading,
          uploadId: payload.uploadId,
        },
      };
      return setIsLoadingRejectUpload;
    }

    case CatalogCsvUploadType.SET_REPORTS_BY_SEASON: {
      const setReportsBySeason: IInitialCatalogCsvUploadState = {
        ...state,
        reportsBySeason: payload,
      };
      return setReportsBySeason;
    }

    case CatalogCsvUploadType.SET_IS_LOADING_BY_SEASON: {
      const setIsLoadingBySeason: IInitialCatalogCsvUploadState = {
        ...state,
        isLoadingBySeason: payload,
      };
      return setIsLoadingBySeason;
    }

    case CatalogCsvUploadType.SET_START_SEASON_DATE: {
      const setStartSeasonDate: IInitialCatalogCsvUploadState = {
        ...state,
        reportsBySeason: state.reportsBySeason.map((report) => {
          if (report.id === payload.id) {
            return { ...report, start: payload.date };
          }
          return report;
        }),
      };
      return setStartSeasonDate;
    }

    case CatalogCsvUploadType.SET_END_SEASON_DATE: {
      const setEndSeasonDate: IInitialCatalogCsvUploadState = {
        ...state,
        reportsBySeason: state.reportsBySeason.map((report) => {
          if (report.id === payload.id) {
            return { ...report, end: payload.date };
          }
          return report;
        }),
      };
      return setEndSeasonDate;
    }

    case CatalogCsvUploadType.SET_PUBLISH_SEASON: {
      const setPublishSeason: IInitialCatalogCsvUploadState = {
        ...state,
        reportsBySeason: state.reportsBySeason.map((report) => {
          if (report.id === payload.id) {
            return { ...report, enabled: payload.enabled };
          }
          return report;
        }),
      };
      return setPublishSeason;
    }

    case CatalogCsvUploadType.SET_IS_LOADING_ENABLE_SEASON: {
      const setIsLoadingEnableSeason: IInitialCatalogCsvUploadState = {
        ...state,
        isLoadingEnableSeason: {
          isLoading: payload.isLoading,
          seasonId: payload.seasonId,
        },
      };
      return setIsLoadingEnableSeason;
    }

    default:
      return state;
  }
}
